module.exports = __webpack_public_path__ + "static/media/Alg1.93f6df33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Alg1.svg
// module id = 872
// module chunks = 21